import { render, staticRenderFns } from "./CosmoKillerDune.vue?vue&type=template&id=7add335d&scoped=true"
import script from "./CosmoKillerDune.vue?vue&type=script&lang=ts"
export * from "./CosmoKillerDune.vue?vue&type=script&lang=ts"
import style0 from "./CosmoKillerDune.vue?vue&type=style&index=0&id=7add335d&prod&lang=scss&scoped=true"
import style1 from "./CosmoKillerDune.vue?vue&type=style&index=1&id=7add335d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7add335d",
  null
  
)

export default component.exports